import axios from "axios";
import auth from "@/services/auth";


export default{
    getAllInstitucije()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/institucije");
          } catch (err) {
            console.log(err);
          }
    },
    getAllInstitucijeShort()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/institucije/short");
          } catch (err) {
            console.log(err);
          }
    },
    getSingleInstitucija(oib)
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/institucije/"+ oib);
          } catch (err) {
            console.log(err);
          }
    },
   async getSingleInstitucijaComunication(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/institucije/"+ oib+"/comunication", {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    
    quickAddInstitucija(institucija) {
      try {
        return axios.post("https://app-psod.cratis.cloud/api/institucije/quick", {
          params: {
            institucija
          },
          credentials: true,
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },
    addInstitucija(institucija) {
      try {
        return axios.post("https://app-psod.cratis.cloud/api/institucije", {
          params: {
            institucija
          },
          credentials: true,
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },
    updateInstitucija(institucija, uid) {
      try {
        return axios.put("https://app-psod.cratis.cloud/api/institucije/" + uid, {
          params: {
            institucija
          },
          credentials: true,
        });
      } catch {
        console.log("Failed attempt at group.");
      }
    },
    deleteInstitucija(uid)
    {
      try {
        return axios.delete("https://app-psod.cratis.cloud/api/institucije/" + uid, {
          credentials: true,
        });
      } catch (err) {
        console.log(err);
      }
    },
}